import { render, staticRenderFns } from "./UsermappingsList.vue?vue&type=template&id=6a5eb0aa"
import script from "./UsermappingsList.vue?vue&type=script&lang=js"
export * from "./UsermappingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports